module.exports = __webpack_public_path__ + "img/370488.75b7be44.svg";